import { MdFileUpload } from "react-icons/md";
import Card from "components/card";
import React, { useRef, useState } from "react";
import api from "services/api";

const Upload = ({ onUpdate }) => {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const key = await api.uploadFile(file, "avatar");
      const res = await api.updateProfile({ avatarUrl: key });
      if (res.success && onUpdate) {
        onUpdate(res.user);
        alert("Profile picture updated successfully!");
      }
    } catch (error) {
      console.error("Avatar upload failed:", error);
      alert("Failed to upload avatar");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Card className="grid h-full w-full grid-cols-1 gap-3 rounded-[20px] bg-white bg-clip-border p-3 font-dm shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none 2xl:grid-cols-11">
      <div className="col-span-5 h-full w-full rounded-xl bg-lightPrimary dark:!bg-navy-700 2xl:col-span-6">
        <button 
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading}
          className="flex h-full w-full flex-col items-center justify-center rounded-xl border-[2px] border-dashed border-gray-200 py-3 dark:!border-navy-700 lg:pb-0 hover:bg-gray-50 transition"
        >
          <MdFileUpload className={`text-[80px] text-brand-500 dark:text-white ${uploading ? 'animate-bounce' : ''}`} />
          <h4 className="text-xl font-bold text-brand-500 dark:text-white">
            {uploading ? "Uploading..." : "Upload Avatar"}
          </h4>
          <p className="mt-2 text-sm font-medium text-gray-600">
            PNG, JPG and GIF files are allowed
          </p>
        </button>
        <input 
          type="file" 
          ref={fileInputRef} 
          className="hidden" 
          accept="image/*" 
          onChange={handleUpload} 
        />
      </div>

      <div className="col-span-5 flex h-full w-full flex-col justify-center overflow-hidden rounded-xl bg-white pl-3 pb-4 dark:!bg-navy-800">
        <h5 className="text-left text-xl font-bold leading-9 text-navy-700 dark:text-white">
          Complete Your Profile
        </h5>
        <p className="leading-1 mt-2 text-base font-normal text-gray-600">
          Upload a clear, professional image so that other administrators can easily identify your changes across the platform.
        </p>
        <button
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading}
          className="linear mt-4 flex items-center justify-center rounded-xl bg-brand-500 px-2 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 disabled:opacity-70"
        >
          {uploading ? "Uploading..." : "Upload New Image"}
        </button>
      </div>
    </Card>
  );
};

export default Upload;
